import { useQuery } from 'react-query';
import { useNotificationStore } from '@/stores/notifications';
import { API_URL } from '@/config';
import axios from 'axios';
import storage from '@/utils/storage';

export const getPublicProjectbyId = async (project_id: string, username?: string): Promise<any> => {
  if (!project_id) {
    return;
  }

  try {
    const url = username
      ? `${API_URL}/v2/project/public/${project_id}?username=${username}`
      : `${API_URL}/v2/project/public/${project_id}`;

    const response = await axios.get(url);

    if (
      response?.data?.data?.has_access === true ||
      response?.data?.data?.visibility === 'private'
    ) {
      storage.clearIsHasProjectAccess();
    } else {
      storage.setIsHasProjectAccess(true);
    }
    return response?.data?.data;
  } catch (error) {
    // throw error;
  }
};

export const useGetPublicProjectbyId = (project_id: any, username?: string, config = {}) => {
  const { addNotification } = useNotificationStore();

  return useQuery<any, Error>(
    ['publicProject', project_id],
    () => getPublicProjectbyId(project_id, username),
    {
      onError: (error: any) => {
        addNotification({
          type: 'error',
          title: 'Failed to fetch project',
          message: error.response?.data?.data || error.message,
        });
      },
      onSuccess: (data) => {},
      ...config,
    }
  );
};
